var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"min-vh-100 d-flex"},[_c('Sidebar'),_c('main',{staticClass:"container-fluid py-2"},[_c('TopNav'),_vm._t("default")],2)],1),_c('Player')],1)}
var staticRenderFns = []

export { render, staticRenderFns }